// extracted by mini-css-extract-plugin
export default {"card":"uew5qa3uljrWcr7zGQFn","request":"BaeKx8o7nCOY9hgYkKXF","date":"kPhkvJcJosnWmwa87vC7"};